import React from "react";
import loginService from '../services/login';
import Cookies from 'universal-cookie';

var UserStateContext = React.createContext();
var UserDispatchContext = React.createContext();

function userReducer(state, action) {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return { ...state, isAuthenticated: true };
      case "LOGIN_FAILURE":
        return { ...state, isAuthenticated: false };
      case "SIGN_OUT_SUCCESS":
      return { ...state, isAuthenticated: false };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function UserProvider({ children }) {
  var [state, dispatch] = React.useReducer(userReducer, {
    isAuthenticated: !!localStorage.getItem("id_token"),
  });

  return (
    <UserStateContext.Provider value={state}>
      <UserDispatchContext.Provider value={dispatch}>
        {children}
      </UserDispatchContext.Provider>
    </UserStateContext.Provider>
  );
}

function useUserState() {
  var context = React.useContext(UserStateContext);
  if (context === undefined) {
    throw new Error("useUserState must be used within a UserProvider");
  }
  return context;
}

function useUserDispatch() {
  var context = React.useContext(UserDispatchContext);
  if (context === undefined) {
    throw new Error("useUserDispatch must be used within a UserProvider");
  }
  return context;
}

export { UserProvider, useUserState, useUserDispatch, loginUser, signOut };

// ###########################################################

async function loginUser(dispatch, login, password, history, setIsLoading, setError) {
  setError(false);
  setIsLoading(true);

  if (!!login && !!password) {

    const resp = await loginService(login, password);
    if (resp.user === null || resp.token === null) {
      dispatch({ type: "LOGIN_FAILURE" });
      setError(true);
      setIsLoading(false);
    } else {

      const cookies = new Cookies();
      cookies.set('token', resp.token);
      cookies.set('username', resp.user.username);
      cookies.set('adminId', resp.user.id);
      cookies.set('userType', resp.user.tipo);

      setError(null)
      setIsLoading(false)
      dispatch({ type: 'LOGIN_SUCCESS' });

      var ref = "";
      switch (resp.user.tipo) {
        case "0":
          ref = "#/app/dashboard";
          break;
        case "1":
          ref = "#/tecnico/ordini";
          break;
        case "2":
          ref = "#/magazzino/entrata-merci";
          break;
        case "3":
          ref = "#/commerciale/dashboard";
          break
        case "4":
          ref = "#/service/ordini";
          break
        default:
          break;
      }
      window.location.href = ref;
      // history.push(`/#/${ref}`);

    }
  } else {
    dispatch({ type: "LOGIN_FAILURE" });
    setError(true);
    setIsLoading(false);
  }
}

function signOut(dispatch, history) {
  const cookies = new Cookies();
  cookies.remove('token');
  dispatch({ type: "SIGN_OUT_SUCCESS" });
  window.location.href = '#/login';
  // history.push("/#/login");
}
